{{#ifExists image}}
	{{! Support legacy image format }}
	{{#ifExists image.src}}
		<div class="answer-image-container" style="background-image:url('{{getPreviewUrl image.src}}')"></div>
	{{else}}
		<div class="answer-image-container" style="background-image:url('{{getPreviewUrl image}}')"></div>
	{{/ifExists}}
{{/ifExists}}
<div class="Text inline-editable" data-attribute="title" data-placeholder="{{t "editor.inspector.properties.title.title"}}">{{{getLocaleTextHTML title}}}</div>
